import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

export const serviceSelector = createSelector(
  [(state: RootState) => state.service],
  (service) => {
    const sortedServices = Boolean(service?.services?.length)
      ? [...service.services].sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime()
        })
      : service?.services

    return {
      ...service,
      services: sortedServices,
    }
  }
)
